export const TAB_IDS = {
    ALL: -1,
    ACTIVE: 2,
    INACTIVE: 1,
    COMPLETED: 3,
    EVENTS: -2,
};

export const TYPE_IDS = {
    ON_GOING: '1',
    TIME_SPANNED: '2',
    EVENT: '3',
};
